import styled from 'styled-components';

// Section style for the image container
export const GallerySection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;  // Full screen height
  padding: 20px;
  background: #f9f9f9;
`;

export const ImageWrapper = styled.div`
  width: 100%; 
  max-width: 800px; /* Limit the width for large screens */
  margin: 0 auto; /* Center horizontally */
  padding: 20px;
  display: flex;
  justify-content: center;
`;

export const GalleryImage = styled.img`
  width: auto; /* Ensure the image takes full width of the container */
 
  max-height:500px;
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  object-fit: cover; /* Ensures the image is nicely contained in its wrapper */
`;
//height:auto